import PropTypes from 'prop-types'
import React from 'react'
import { getSvgIconUrl } from '../../parameters'
import { hexToCssFilter, hexToRgb } from '../utils/css'
import { useHover } from '../utils/hover'
import s from './CircledButtonWithLabel2.less'

const CircledButtonWithLabel2 = ({ iconId, logoUrl, label, onClick, primaryColor }) => {
  const [hoverRef, isHovered] = useHover()

  if (!iconId && !logoUrl) return <></>

  const filter = !logoUrl && hexToCssFilter(primaryColor)

  return (
    <span className={s.container} onClick={onClick} ref={hoverRef}>
      {logoUrl ? (
        <img src={logoUrl} className={s.logo} />
      ) : (
        <span
          className={s.iconContainer}
          style={{
            borderColor: hexToRgb(primaryColor, 0.5),
            filter
          }}
          width={26}
          height={26}
        >
          <img
            className={s.icon}
            src={getSvgIconUrl(global.__SVG_TIMESTAMP__, iconId)}
            style={{ filter }}
            alt={iconId}
            width={26}
            height={26}
          />
        </span>
      )}

      <span className={s.label} style={{ color: isHovered && primaryColor }}>
        {label}
      </span>
    </span>
  )
}

CircledButtonWithLabel2.propTypes = {
  iconId: PropTypes.string,
  logoUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  style: PropTypes.object,
  primaryColor: PropTypes.string
}

export default CircledButtonWithLabel2
